import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const EventTopBarTelemetry = createTelemetryObject({
  actions: {
    logoClicked: () => ({
      action: 'TravelButtonInteracted',
      category: 'travel',
      pagePrefix: 'guest',
      page: 'stays',
      extraInfo: {
        name: 'logoClicked',
      },
    }),
  },
});

const { TelemetryProvider, useTelemetry: useEventTopBarTelemetry } = createTelemetry(EventTopBarTelemetry);
export { TelemetryProvider, useEventTopBarTelemetry };
